import React, { Component } from 'react';
import { seq } from 'async';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { each, pick, reduce } from 'lodash';
import { Modal, Button, FormGroup, HelpBlock, FormControl } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import draftToHtml from 'draftjs-to-html';
import Joi from 'joi';
import {
  EditorState, convertToRaw, ContentState,
  CompositeDecorator,
} from 'draft-js';
import { Field, reduxForm, SubmissionError, formValueSelector } from 'redux-form';
import SenderField from '../../../Feedback/components/edit-sender-modal/field';
import { getCanSetupOrganization } from '../../../Auth/AuthReducer';
import Editor from '../../../../components/editor';
import {
  requestShowSurveyEmail,
  winLossSendNextEmail,
  winLossScheduleNextEmail,
  updateSenderEmail,
  winLossPreviewNextEmail,
} from '../../DashboardActions';
import { getWinLossCurrentEmail, getFeedbackRequestSettings } from '../../DashboardReducer';
import styles from './styles.css';
import RescheduleButton from './RescheduleButton';

let htmlToDraft = () => null;

const MODE_SEND_NOW = 'MODE_SEND_NOW';
const MODE_SEND_LATER = 'MODE_SEND_LATER';

function findImageEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(
    (character) => {
      const entityKey = character.getEntity();
      if (entityKey !== null && contentState.getEntity(entityKey).getType() === 'IMAGE') {
        console.log('!!!!!!entityKeyentityKey', entityKey, contentState.getEntity(entityKey).getType());
      }
      return (
        entityKey !== null &&
        contentState.getEntity(entityKey).getType() === 'IMAGE'
      );
    },
    callback,
  );
}
const Image = (props) => {
  const {
    height,
    src,
    width,
    alt,
  } = props.contentState.getEntity(props.entityKey).getData();

  return (
    <img alt={alt} src={src} height={height} width={width} />
  );
};

Image.propTypes = {
  contentState: PropTypes.shape({
    getEntity: PropTypes.func.isRequired,
  }).isRequired,
  entityKey: PropTypes.string.isRequired,
};

class SurveyEmailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isNext: false,
      editorState: null,
      focus: false,
      rescheduling: false,
      selectedDate: null,
      changed: false,
      selectedEmail: null,
      changeEmailError: null,
      changedEmail: false,
      ready: false,
      previewApiAvailable: false,
      loadingPreview: false,
      showPreview: false,
      previewSubject: null,
      previewMessage: null,
      rawPreviewMessage: null,
    };
    this.close = this.close.bind(this);
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.renderEditor = this.renderEditor.bind(this);
    this.renderField = this.renderField.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.sendNow = this.sendNow.bind(this);
    this.sendLater = this.sendLater.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.showPreview = this.showPreview.bind(this);
    this.closePreview = this.closePreview.bind(this);
    this.handleCopy = this.handleCopy.bind(this);
    this.decorators0 = [];
    this.decorators = [
      {
        strategy: findImageEntities,
        component: Image,
      },
    ];
  }
  componentDidMount() {
    import('html-to-draftjs').then((f)=> {
      htmlToDraft = f.default;
      this.state = {
        ready: true,
      };
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.email.contact_id && nextProps.email.contact_id !== this.props.email.contact_id) {
      let { message } = nextProps.email;
      if (message) {
        const re = new RegExp(/<p[^>]*><br[^>]*><\/p>/, 'g');
        message = message.replace(re, '<p></p>');
        const re2 = new RegExp(/<p[^>]*><span[^>]*><br[^>]*><\/span><\/p>/, 'g');
        message = message.replace(re2, '<p></p>');
      }

      message = `<div>${message}</div>`; // https://github.com/lumen-software/TruSales/issues/1559

      // const contentBlock = htmlToDraft(message);
      // const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      // const editorState = EditorState.createWithContent(contentState);

      const compositeDecorator = new CompositeDecorator(this.decorators);
      const contentBlock = htmlToDraft(message, (nodeName, node) => {
        if (nodeName === 'img') {
          const data = pick(node, ['src', 'alt', 'width', 'height', 'alignment']);
          if (data.height === 0) {
            delete data.height;
          }
          if (data.width === 0) {
            delete data.width;
          }
          if (!data.alignment) {
            data.alignment = 'left';
          }
          return {
            type: 'IMAGE',
            mutability: 'MUTABLE',
            data,
          };
        }
      });
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks, contentBlock.entityMap);
      const editorState = EditorState.createWithContent(contentState, compositeDecorator);
      this.props.initialize(nextProps.email);
      let selectedEmail = null;
      if (nextProps.email.isNext && nextProps.email.email_from && nextProps.email.email_from.email && nextProps.email.email_from.email.length > 0) {
        selectedEmail = nextProps.email.email_from.email;
      }
      this.setState({
        selectedEmail,
        isNext: nextProps.email.isNext,
        editorState,
      }, () => {
        this.showPreview(null, true);
      });
    }
  }

  onEditorStateChange(editorState) {
    this.setState({
      editorState,
      changed: true,
    });
    const description = draftToHtml(convertToRaw(editorState.getCurrentContent()), null, null, this.customEntityTransform);
    this.props.change('message', description);
  }
  getTimes(date) {
    const { email } = this.props;
    let foreignTime = null;
    const localTime = {
      date: moment(date),
    };
    if (email.time_zone !== null && email.time_zone !== undefined && email.time_zone.utc !== null) {
      localTime.date = moment(date).tz(email.time_zone.utc);
      foreignTime = {
        date: moment(date),
        utc: email.time_zone.utc,
        text: email.time_zone.text,
      };
    }
    return {
      localTime,
      foreignTime,
    };
  }

  customEntityTransform({ type, data }) {
    if (type === 'IMAGE') {
      const attrs = [];
      each(data, (v, k) => {
        attrs.push(`${k}="${v}"`);
      });
      return `<img ${attrs.join(' ')} />`;
    }
  }

  close() {
    this.setState({
      rescheduling: false, selectedDate: null, changed: false, selectedEmail: null,
      changeEmailError: null, changedEmail: false,
    });
    this.props.dispatch(requestShowSurveyEmail({}));
  }

  closePreview() {
    this.setState({ showPreview: false });
  }

  showPreview(ev, firstTime = false) {
    const { email, currentMessage, currentSubject } = this.props;
    const isAccount = email.is_account;
    const id = isAccount ? email.account_id : email.opportunity_id;
    const collectorId = email.collector_id;
    const contactId = email.contact_id;
    const stepId = email.step_id;
    const params = {
      subject: currentSubject,
      message: `<div>${currentMessage}</div>`,
    };
    if (!firstTime) {
      this.setState({ loadingPreview: true });
    }
    this.props.dispatch(winLossPreviewNextEmail(collectorId, id, contactId, stepId, params, isAccount))
      .then(
        (results) => {
          if (firstTime) {
            this.setState({ previewApiAvailable: true });
          } else {
            const contentBlock = htmlToDraft(results.next_scheduled_message);
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks, contentBlock.entityMap);
            const editorState = EditorState.createWithContent(contentState);

            this.setState({
              previewSubject: results.next_scheduled_subject,
              previewMessage: editorState,
              rawPreviewMessage: results.next_scheduled_message,
              showPreview: true,
              loadingPreview: false,
            });
          }
        },
        (e) => {
          if (firstTime && e && e.status === 400) {
            // TV API not available yet
            this.setState({ previewApiAvailable: false, showPreview: false, loadingPreview: false });
          }
        },
      );
  }

  sendNow() {
    const { handleSubmit } = this.props;
    this.mode = MODE_SEND_NOW;
    return handleSubmit(this.handleSubmit)();
  }

  sendLater() {
    const { handleSubmit } = this.props;
    this.mode = MODE_SEND_LATER;
    return handleSubmit(this.handleSubmit)();
  }

  handleCopy(e) {
    const { previewApiAvailable } = this.state;
    const selection = document.getSelection();
    const slectionString = selection.toString();
    const invalidTokens = ['SurveyCollectorOutlineHTMLAnchor', 'SurveyCollectorOutlineURL'];

    if (slectionString && slectionString.length) {
      const invalid = reduce(invalidTokens, (items, token) => {
        if (slectionString.indexOf(token) >= 0) {
          items.push(token);
        }
        return items;
      }, []);
      if (invalid.length > 0) {
        let msg = 'Survey URL is generated when emails are sent. It cannot be copied.';
        if (previewApiAvailable) {
          msg = `${msg} Please use preview mode to copy the email content.`;
        }
        e.preventDefault();
        const el = (
          <div>{msg}</div>
        );
        this.context.addNotification(el, { type: 'error', autoClose: false });
      }
    }
  }

  handleFocus() {
    this.setState({ focus: true });
  }
  handleBlur() {
    this.setState({ focus: false });
  }

  handleDateChange(requestedDate) {
    // change on save
    /*
    const { email } = this.props;
    const contactId = email.contact_id;
    const collectorId = email.collector_id;
    const isAccount = email.is_account;
    const id = isAccount ? email.account_id : email.opportunity_id;
    const stepId = email.step_id;
    
    this.setState({ rescheduling: true }, () => {
      this.props.dispatch(winLossRequestReschedule(collectorId, id, contactId, stepId, moment(date).format('YYYY-MM-DD'), isAccount))
        .then(
          () => {
            this.setState({ rescheduling: false });
          },
          () => {
            this.setState({ rescheduling: false });
          },
        );
    });
    */
    const { email } = this.props;
    const translatedDate = moment(email.date)
      .date(requestedDate.date())
      .month(requestedDate.month())
      .year(requestedDate.year());

    // const { localTime, foreignTime } = this.getTimes(selectedDate || email.date);
    // console.log('emaildate', moment(email.date));
    // console.log('requestedDate', requestedDate);
    // console.log('translatedDate', translatedDate);

    this.setState({ selectedDate: translatedDate });
  }

  handleSubmitContent(params) {
    const submitParams = {
      message: params.message,
      subject: params.subject,
    };
    const { email } = this.props;
    const collectorId = params.collector_id;
    if (this.mode === MODE_SEND_LATER && this.state.selectedDate) {
      submitParams.date = moment(this.state.selectedDate).startOf('day').toDate();
    }
    const contactId = params.contact_id; // TV id
    const action = this.mode === MODE_SEND_LATER ? winLossScheduleNextEmail : winLossSendNextEmail;
    const isAccount = email.is_account;
    const id = isAccount ? params.account_id : params.opportunity_id;
    const stepId = email.step_id;
    const args = this.mode === MODE_SEND_LATER ?
      [collectorId, email.time_zone, id, contactId, stepId, submitParams, isAccount] :
      [collectorId, email.time_zone, id, contactId, submitParams, isAccount];

    const p = this.props.dispatch(action(...args));

    p.then(
      () => {
        if (this.mode === MODE_SEND_LATER) {
          this.props.onSchedule();
          this.close();
        } else {
          const el = (
            <div>
              An email has been sent to {email.name} <span>({email.email})</span>
            </div>
          );
          this.context.addNotification(el, { type: 'success', autoClose: false });
          this.props.onSent();
          this.close();
        }
      },
      (errors) => {
        let e = errors;
        if (errors.data) {
          e = errors.data;
          if (errors.data.responseBody) {
            e = errors.data.responseBody;
          }
        }
        throw new SubmissionError(e);
      },
    );

    return p;
  }

  handleSubmit(params) {
    this.setState({ changeEmailError: null });
    return new Promise((resolve, reject) => {
      seq(
        (callback) => {
          const { email } = this.props;
          let currentEmail = null;
          if (email.email_from && email.email_from.email && email.email_from.email !== '') {
            currentEmail = email.email_from.email;
          }
          if (currentEmail !== this.state.selectedEmail) {
            const objectId = email.is_account ? email.account_id : email.opportunity_id;
            this.props.dispatch(updateSenderEmail(email.collector_id, objectId, email.id || email.contact_id, this.state.selectedEmail, email.is_account))
              .then(
                () => {
                  callback(null, true);
                },
                (e) => {
                  this.setState({ changeEmailError: e.message ? e.message : 'Cannot change sender email' });
                  callback(e);
                },
              );
          } else {
            callback(null, true);
          }
        },
        (success, callback) => {
          this.handleSubmitContent(params)
            .then(
              (r) => {
                callback(null, r);
              },
              (e) => {
                callback(e);
              },
            );
        },
      )((errors, results) => {
        if (errors) {
          reject(errors);
        } else {
          resolve(results);
        }
      });
    });
  }
  
  renderHTML(raw) {
    return <span dangerouslySetInnerHTML={{ __html: raw }} />;
  }

  renderTime(localTime, foreignTime, isNext = false) {
    const { rescheduling } = this.state;
    const { submitting } = this.props;

    let comp = (<span>unknown</span>);
    if (localTime.date && localTime.date.isValid()) {
      const format = 'MMM DD, YYYY \\a\\t hh:mm A';
      let localSuffix = null;
      const localStr = localTime.date.format(format);
      let foreignTimeStr = null;
  
      if (foreignTime !== null) {
        foreignTimeStr = foreignTime.date.format(format);
      }
      if (foreignTimeStr && foreignTimeStr !== localStr) {
        localSuffix = (<span className="label label-default text-uppercase">local time</span>);
      }
      comp = (
        <div>
          <div><nobr>{localStr} {localSuffix}</nobr></div>
          {foreignTime !== null && foreignTimeStr !== localStr &&
            <div>
              <nobr><em>or</em>&nbsp; {foreignTimeStr} <span className="label label-default text-uppercase">{foreignTime.utc}</span></nobr>
            </div>
          }
        </div>
      );
    }

    if (!isNext) {
      return comp;
    }
    return (
      <RescheduleButton
        disabled={submitting || rescheduling}
        rescheduling={rescheduling}
        localTime={localTime}
        foreignTime={foreignTime}
        onChange={this.handleDateChange}
      >
        {comp}
      </RescheduleButton>
    );
  }


  renderField({
    input, label, componentClass, type, meta: { touched, error }, disabled,
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState} style={{ margin: 0 }}>
        <FormControl
          {...input}
          componentClass={componentClass}
          placeholder={label}
          type={type}
          disabled={(submitting || disabled)}
        />
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  renderEditor({
    editorState, focus, meta: { touched, error }, disabled,
  }) {
    const { changed } = this.state;
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup onCopy={this.handleCopy} validationState={validationState} className={styles.descriptionEditor}>
        <Editor
          editorState={editorState}
          onEditorStateChange={this.onEditorStateChange}
          wrapperClassName={styles.editorWrapper}
          editorClassName={`${styles.editor} ${focus ? styles.editorFocus : ''}`}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          disabled={(submitting || disabled)}
          customDecorators={this.decorators}
          toolbar={{
            options: [
              'inline', 'blockType', 'fontSize',
              'fontFamily', 'list', 'textAlign', 'colorPicker',
              'link', 'emoji', 'remove', 'history',
            ],
            inline: {
              options: ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript'],
            },
          }}
        />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
        {changed && <div style={{ marginTop: '10px' }} className="alert alert-danger animated flash">WARNING: Do not edit or change the &ldquo;survey&rdquo; link in the email. The link is specific to the contact and will break the process if it&rsquo;s edited.</div>}
      </FormGroup>
    );
  }

  renderFromField() {
    const { email, submitting, canChangeSenderEmail } = this.props;
    const { isNext, selectedEmail, changeEmailError } = this.state;
    let sendFromName = null;
    let sendFromEmail = null;
    if (email.email_from) {
      sendFromName = email.email_from.name && email.email_from.name.length > 0 ? email.email_from.name : null;
      sendFromEmail = email.email_from.email && email.email_from.email.length > 0 ? email.email_from.email : null;
    }
    if (sendFromEmail !== null || isNext) {
      const objectId = email.is_account ? email.account_id : email.opportunity_id;
      return (
        <tr>
          <td><strong>From:</strong></td>
          {(!isNext || !canChangeSenderEmail) && <td>{sendFromName} <code>{sendFromEmail}</code></td>}
          {isNext && canChangeSenderEmail &&
            <td>
              <FormGroup style={{ margin: 0 }} validationState={(changeEmailError !== null ? 'error' : null)}>
                <SenderField
                  survey={{ ...email, object_id: objectId, object: { [email.is_account ? 'account_id' : 'opportunity_id']: objectId } }}
                  isAccount={email.is_account}
                  selectedEmail={selectedEmail}
                  submitting={submitting}
                  onCancel={this.close}
                  onSelectEmail={(e) => { this.setState({ selectedEmail: e, changeEmailError: null, changedEmail: true }); }}
                />
                {changeEmailError !== null && <HelpBlock>{changeEmailError}</HelpBlock>}
              </FormGroup>
            </td>
          }
        </tr>
      );
    }
    return null;
  }

  renderPreviewModal() {
    const { showPreview, previewSubject, rawPreviewMessage } = this.state;
    return (
      <Modal
        show={showPreview}
        onHide={this.closePreview}
        bsSize="lg"
      >
        <Modal.Header closeButton>Preview Email</Modal.Header>
        <Modal.Body>
          <table className="table table-condensed">
            <tbody>
              <tr>
                <th width="100">Subject:</th>
                <td>{previewSubject}</td>
              </tr>
              <tr>
                <td colSpan="2">
                  {false && <div><strong>Message:</strong></div>}
                  <p />
                  <div>
                    <div dangerouslySetInnerHTML={{ __html: rawPreviewMessage }} />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <hr />
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="default" onClick={this.closePreview}>Done</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const {
      email, submitting, valid,
      feedbackRequestSettings,
    } = this.props;
    const show = email.contact_id !== undefined;
    const {
      isNext, focus, editorState,
      selectedDate, previewApiAvailable,
      loadingPreview, showPreview,
    } = this.state;
    let { title } = this.props;
    if (!title) {
      const stepName = email.step_name;
      if (stepName) {
        title = `Email for step: ${stepName}`;
      } else {
        title = isNext ? 'Next Email' : 'Last Email Sent';
      }
    }
    let { dateLabel } = this.props;
    if (!dateLabel) {
      dateLabel = isNext ? 'Scheduled' : 'Sent on';
    }
    const cls = [styles.dialog];
    const { scheduleOnly } = email;
    let isManual = false;
    if (isNext && email.date === 'Manual') {
      isManual = true;
    } else if (email.is_manual) {
      isManual = true;
    }
    const { mode } = this;
    const isSchedudling = mode === MODE_SEND_LATER && submitting;
    const isSending = mode === MODE_SEND_NOW && submitting;
    if (isSending) {
      cls.push(styles.dialogSm);
    }
    const status = !isNext && email.status ? email.status : null;
    const statusCls = status === 'SENT' ? 'label-success' : 'label-default';
    const { localTime, foreignTime } = this.getTimes(selectedDate || email.date);

    const disabled = !feedbackRequestSettings || feedbackRequestSettings.email_editing !== true;

    const previewBtn = previewApiAvailable ?
      (
        <Button onClick={this.showPreview} disabled={loadingPreview || submitting || !valid} bsStyle="default">
          <span><Fa spin={isSchedudling} name={loadingPreview ? 'spinner' : 'eye'} /> Preview</span>
        </Button>
      ) : null;

    if (showPreview) {
      return this.renderPreviewModal();
    }
    return (
      <div>
        <Modal
          show={show}
          onHide={this.close}
          bsSize={isSending ? 'sm' : 'lg'}
          dialogClassName={cls.join(' ')}
          backdrop={submitting ? 'static' : true}
        >
          <form>
            {isSending &&
              <div>
                <Modal.Body />
              </div>
            }
            {!isSending &&
              <div>
                {show && <Modal.Header closeButton>{title}</Modal.Header>}
                {show &&
                  <Modal.Body>
                    <table className="table table-condensed">
                      <tbody>
                        {this.renderFromField()}
                        <tr>
                          <td><strong>To:</strong></td>
                          <td>{email.name} <code>{email.email}</code></td>
                        </tr>
                        <tr>
                          <td><strong>{dateLabel}:</strong></td>
                          <td>
                            {(!isManual || !isNext) && this.renderTime(localTime, foreignTime, isNext)}
                            {isManual && isNext && <em>manual</em>}
                          </td>
                        </tr>
                        {!isNext && status !== null &&
                          <tr>
                            <td><strong>Status:</strong></td>
                            <td><span className={`label ${statusCls}`}>{status}</span></td>
                          </tr>
                        }
                        <tr>
                          <td><strong>Subject:</strong></td>
                          <td>
                            {(!isNext || disabled) && <span>{email.subject}</span>}
                            {(isNext && !disabled) &&
                              <Field
                                name="subject"
                                component={this.renderField}
                                label="Subject"
                                disabled={disabled}
                              />
                            }
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="2">
                            <div><strong>Message:</strong></div>
                            {(!isNext || disabled) && <div style={{ maxHeight: 400, overflow: 'auto' }} className="dont-break-out">{this.renderHTML(email.message)}</div>}
                            {(isNext && !disabled) &&
                              <Field
                                name="message"
                                focus={focus}
                                editorState={editorState}
                                disabled={disabled}
                                component={this.renderEditor}
                                label="Message"
                              />
                            }
                          </td>
                        </tr>
                      </tbody>
      
                    </table>
                  </Modal.Body>
                }
                {isNext &&
                  <Modal.Footer>
                    <div className="clearfix">
                      <div className="pull-left">
                        <Button disabled={submitting} className="pull-left" bsStyle="link" onClick={this.close}>Cancel</Button>
                      </div>
                      {!scheduleOnly &&
                        <div className="pull-right text-right">
                          {previewBtn}
                          <Button onClick={this.sendLater} disabled={submitting || !valid} bsStyle="default">
                            <span>Send When Scheduled</span>
                            <span>&nbsp;<Fa spin={isSchedudling} name={isSchedudling ? 'spinner' : 'calendar-o'} /></span>
                          </Button>
                          <Button onClick={this.sendNow} disabled={submitting || !valid} bsStyle="primary">
                            <span>Send Now</span>
                            <span>&nbsp;<Fa spin={isSending} name={isSending ? 'spinner' : 'send'} /></span>
                          </Button>
                        </div>
                      }
                      {scheduleOnly &&
                        <div className="pull-right text-right">
                          {previewBtn}
                          <Button onClick={this.sendLater} disabled={submitting || !valid} bsStyle="primary">
                            <span><Fa spin={isSchedudling} name={isSchedudling ? 'spinner' : 'save'} /> Save</span>
                          </Button>
                        </div>
                      }
                    </div>
                  </Modal.Footer>
                }
                {!isNext &&
                  <Modal.Footer>
                    <Button bsStyle="link" onClick={this.close}>Done</Button>
                  </Modal.Footer>
                }
              </div>
            }
          </form>
        </Modal>
        
      </div>
    );
  }
}

const selector = formValueSelector('surveyNextEmailForm'); // <-- same as form name

SurveyEmailModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  email: PropTypes.shape({
    id: PropTypes.string,
    step_id: PropTypes.string,
    subject: PropTypes.string,
    message: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string,
    contact_id: PropTypes.string,
    isNext: PropTypes.bool,
    status: PropTypes.string,
    opportunity_id: PropTypes.string,
    collector_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    date: PropTypes.oneOfType([PropTypes.instanceOf(moment), PropTypes.number]),
    is_manual: PropTypes.bool,
    is_account: PropTypes.bool,
    time_zone: PropTypes.shape({
      utc: PropTypes.string,
      text: PropTypes.string,
    }),
    scheduleOnly: PropTypes.bool,
    step_name: PropTypes.string,
    email_from: PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string,
    }),
  }),
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  change: PropTypes.func,
  initialize: PropTypes.func,
  valid: PropTypes.bool.isRequired,
  onSent: PropTypes.func,
  onSchedule: PropTypes.func,
  dateLabel: PropTypes.string,
  feedbackRequestSettings: PropTypes.shape({
    email_editing: PropTypes.bool,
  }),
  title: PropTypes.string,
  canChangeSenderEmail: PropTypes.bool,
  currentSubject: PropTypes.string,
  currentMessage: PropTypes.string,
};
SurveyEmailModal.defaultProps = {
  email: {},
  change: () => {},
  handleSubmit: () => {},
  submitting: false,
  initialize: () => {},
  onSent: () => {},
  onSchedule: () => {},
  feedbackRequestSettings: {
    email_editing: false,
  },
  dateLabel: null,
  title: null,
  canChangeSenderEmail: false,
  currentSubject: '',
  currentMessage: '',
};
SurveyEmailModal.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};

// Retrieve data from store as props
function mapStateToProps(state) {
  const email = getWinLossCurrentEmail(state);
  return {
    initialValues: { ...email },
    email,
    canChangeSenderEmail: getCanSetupOrganization(state),
    feedbackRequestSettings: getFeedbackRequestSettings(state),
    currentSubject: selector(state, 'subject'),
    currentMessage: selector(state, 'message'),
  };
}
const validate = (values) => {
  // Legacy constraints for reference:
  // const constraints = {
  //   message: {
  //     presence: true,
  //     length: {
  //       minimum: 1,
  //     },
  //   },
  //   subject: {
  //     presence: true,
  //     length: {
  //       minimum: 1,
  //       maximum: 2048,
  //     },
  //   },
  // };

  const schema = Joi.object({
    message: Joi.string().min(1).required().messages({
      'string.base': 'Message must be a string',
      'string.empty': 'Message is required',
      'any.required': 'Message is required',
      'string.min': 'Message is required',
    }),
    subject: Joi.string().min(1).max(2048).required().messages({
      'string.base': 'Subject must be a string',
      'string.empty': 'Subject is required',
      'any.required': 'Subject is required',
      'string.min': 'Subject is required',
      'string.max': 'Subject must be at most 2048 characters',
    }),
  }).unknown(true);

  const { error } = schema.validate(values, { abortEarly: false });
  if (!error) return {};
  
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};
const SurveyNextEmailForm = reduxForm({
  form: 'surveyNextEmailForm',
  validate,
})(SurveyEmailModal);


export default connect(mapStateToProps)(SurveyNextEmailForm);
